// eslint-disable max-classes-per-file
import AppStore from './app';
import { useStore } from '../storeProvider';

export default class RootStore {
    constructor(initial) {
        this.app = new AppStore(initial);
        window.store = this; // TODO: make available in dev only. - RichC
    }
}

export const useAppStore = () => useStore('app');
